import '@fancyapps/fancybox/dist/jquery.fancybox.js';
